var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0ZM28 4C41.234 4 52 14.766 52 28C52 41.234 41.234 52 28 52C14.766 52 4 41.234 4 28C4 14.766 14.766 4 28 4Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0254 40.1228C17.3669 35.3251 22.2841 32 27.9997 32C33.7142 32 38.6325 35.325 40.9741 40.1228C41.4585 41.1155 41.0466 42.3129 40.0539 42.7974C39.0613 43.2818 37.8638 42.8699 37.3794 41.8772C35.6789 38.393 32.1192 36 27.9997 36C23.8793 36 20.3206 38.3929 18.6201 41.8772C18.1356 42.8699 16.9382 43.2818 15.9455 42.7974C14.9529 42.3129 14.5409 41.1155 15.0254 40.1228Z",
    fill: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 17C15.791 17 14 18.791 14 21C14 23.209 15.791 25 18 25C20.209 25 22 23.209 22 21C22 18.791 20.209 17 18 17Z",
    fill: "#9E9E9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 17C35.791 17 34 18.791 34 21C34 23.209 35.791 25 38 25C40.209 25 42 23.209 42 21C42 18.791 40.209 17 38 17Z",
    fill: "#9E9E9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0ZM28 4C41.234 4 52 14.766 52 28C52 41.234 41.234 52 28 52C14.766 52 4 41.234 4 28C4 14.766 14.766 4 28 4Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/page-not-found.9ec4fc5f1a9f01ff73af79da79c738ff.svg";
export { ForwardRef as ReactComponent };